import { render } from "./EditingSectionFolder.vue?vue&type=template&id=510a008a"
import script from "./EditingSectionFolder.vue?vue&type=script&lang=js"
export * from "./EditingSectionFolder.vue?vue&type=script&lang=js"
script.render = render

export default script